import { Skeleton } from './skeleton';

export function SkeletonTroedelDay({ testid = 'skeleton-troedel-day' }) {
  return (
    <div data-testid={testid} className="bg-[var(--bg-L1)] border border-[var(--border-default)] rounded-2xl p-4">
      <div className="flex items-center justify-between">
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-28 rounded" />
          <Skeleton className="h-4 w-20 rounded" />
        </div>
        <div className="flex items-center gap-3">
          <div className="text-right space-y-1">
            <Skeleton className="h-5 w-14 rounded" />
            <Skeleton className="h-3 w-16 rounded" />
          </div>
          <Skeleton className="h-5 w-5 rounded" />
        </div>
      </div>
    </div>
  );
}
